'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuthStore } from '@/entities/auth';
import { useLanguage } from '@/features/language';
import { ENV } from '@/shared/config';
import { getHostOrigin } from '@/shared/lib/path';
import { login } from '@/shared/utils';
import { cn } from '@ncai-axe/react-ui-v3';
import { useRouter } from 'next/navigation';
import styles from './styles.module.scss';
type Props = {
  variant?: 'primary' | 'outline' | 'outlineGray';
  className?: string;
  children: React.ReactNode;
};
export function CTAButton(t0) {
  const $ = _c(11);
  const {
    variant: t1,
    className,
    children
  } = t0;
  const variant = t1 === undefined ? "primary" : t1;
  const router = useRouter();
  const [locale] = useLanguage();
  const isAuthenticated = useAuthStore(_temp);
  let t2;
  if ($[0] !== isAuthenticated || $[1] !== locale || $[2] !== router) {
    t2 = () => {
      const productsPath = `/${locale}/products`;
      if (isAuthenticated) {
        router.push(productsPath);
        return;
      }
      login(ENV.AUTH_API_BASE_URL, `${getHostOrigin()}${productsPath}`);
    };
    $[0] = isAuthenticated;
    $[1] = locale;
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleClick = t2;
  const t3 = styles[variant];
  let t4;
  if ($[4] !== className || $[5] !== t3) {
    t4 = cn(styles.ctaButton, t3, className);
    $[4] = className;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== handleClick || $[9] !== t4) {
    t5 = <button type="button" className={t4} onClick={handleClick}>{children}</button>;
    $[7] = children;
    $[8] = handleClick;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp(s) {
  return s.isAuthenticated;
}